import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Wind, 
  Thermometer, 
  Snowflake, 
  Fan, 
  Wrench,
  Phone,
  FileText,
  CheckCircle,
  Clock,
  Shield,
  Zap,
  Leaf,
  Building2
} from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const ServicesPage = () => {
  const services = [
    {
      id: "climatisation",
      icon: Wind,
      title: "Climatisation",
      subtitle: "Pose, dépannage et entretien de climatisation",
      description: "ADM Confort Clim, installateur climatisation basé en Seine-et-Marne, réalise la pose, le dépannage et l'entretien de vos systèmes de climatisation. Intervention en Île-de-France et dans toute la France.",
      features: [
        "Pose de climatisation split et multi-split",
        "Installation climatisation gainable",
        "Dépannage climatisation toutes marques",
        "Entretien climatisation annuel",
        "Climatisation réversible chaud/froid"
      ],
      benefits: [
        { icon: Zap, text: "Intervention rapide" },
        { icon: Shield, text: "Garantie décennale" },
        { icon: Thermometer, text: "Confort toute l'année" },
        { icon: Clock, text: "Dépannage 24h/24" }
      ],
      brands: "Daikin, Mitsubishi Electric, Atlantic, Toshiba, Panasonic, Hitachi, LG, Carrier",
      image: "https://customer-assets.emergentagent.com/job_adm-confort-clim/artifacts/s5eba2in_installation-climatisation-restaurant-plafond-commercial-seine-et-marne-adm-confort-clim.webp.jpeg"
    },
    {
      id: "pompe-a-chaleur",
      icon: Thermometer,
      title: "Pompe à Chaleur Air/Eau",
      subtitle: "Installation, dépannage et entretien PAC",
      description: "Spécialiste pompe à chaleur air/eau basé en Seine-et-Marne, nous assurons l'installation, le dépannage et l'entretien de votre PAC partout en France. Réduisez vos factures jusqu'à 70% avec une énergie renouvelable.",
      features: [
        "Installation pompe à chaleur air/eau",
        "Dépannage pompe à chaleur toutes marques",
        "Entretien pompe à chaleur annuel",
        "Remplacement chaudière fioul/gaz",
        "Plancher chauffant et chauffe-eau thermodynamique"
      ],
      benefits: [
        { icon: Leaf, text: "Jusqu'à 70% d'économies" },
        { icon: Shield, text: "Éligible aides État" },
        { icon: Zap, text: "Énergie renouvelable" },
        { icon: Building2, text: "Valorisation immobilière" }
      ],
      brands: "Daikin, Mitsubishi Electric, Atlantic, Toshiba, Panasonic, Hitachi",
      image: "https://customer-assets.emergentagent.com/job_adm-confort-clim/artifacts/aoe4xejv_WhatsApp%20Image%202026-03-15%20at%2022.05.58.jpeg"
    },
    {
      id: "froid-commercial",
      icon: Snowflake,
      title: "Froid Commercial",
      subtitle: "Chambre froide et vitrine réfrigérée",
      description: "Frigoriste professionnel basé en Seine-et-Marne, ADM Confort Clim réalise le montage, le dépannage et l'entretien de chambres froides et vitrines réfrigérées pour restaurants, commerces, boucheries et tous professionnels en France.",
      features: [
        "Montage chambre froide positive et négative",
        "Dépannage chambre froide urgent",
        "Montage vitrine réfrigérée",
        "Installation meuble frigorifique",
        "Maintenance préventive HACCP"
      ],
      benefits: [
        { icon: Shield, text: "Conformité HACCP" },
        { icon: Zap, text: "Intervention rapide" },
        { icon: Clock, text: "Dépannage 24h/24" },
        { icon: Wrench, text: "Maintenance préventive" }
      ],
      brands: "Toutes marques professionnelles",
      image: "https://customer-assets.emergentagent.com/job_adm-confort-clim/artifacts/qv5ds9gy_installation-climatisation-cassette-commerce-seine-et-marne-adm-confort-clim.webp.jpeg"
    },
    {
      id: "ventilation",
      icon: Fan,
      title: "Ventilation",
      subtitle: "VMC simple flux, double flux et réseau aéraulique",
      description: "Installation de systèmes de ventilation : VMC simple flux, VMC double flux, réseau aéraulique et moteur d'extraction. Assurez une qualité d'air optimale dans vos locaux partout en France.",
      features: [
        "Installation VMC simple flux",
        "Installation VMC double flux",
        "Montage réseau aéraulique",
        "Installation moteur d'extraction",
        "Récupération de chaleur"
      ],
      benefits: [
        { icon: Wind, text: "Air sain et renouvelé" },
        { icon: Thermometer, text: "Élimination humidité" },
        { icon: Shield, text: "Réduction allergènes" },
        { icon: Zap, text: "Économies d'énergie" }
      ],
      brands: "Atlantic, Aldes, Unelvent, S&P",
      image: "https://customer-assets.emergentagent.com/job_adm-confort-clim/artifacts/bod0pe3z_installation-reseau-aeraulique-gaine-ventilation-locaux-professionnels-seine-et-marne.jpg"
    },
    {
      id: "depannage",
      icon: Wrench,
      title: "Dépannage Urgent 24h/24",
      subtitle: "Intervention rapide 7j/7 partout en France",
      description: "Service de dépannage urgent climatisation, pompe à chaleur et chambre froide. Disponible 24h/24 et 7j/7 en Île-de-France et dans toute la France. Nos techniciens interviennent rapidement pour résoudre vos pannes.",
      features: [
        "Dépannage climatisation urgent",
        "Dépannage pompe à chaleur",
        "Dépannage chambre froide",
        "Diagnostic rapide",
        "Intervention toutes marques"
      ],
      benefits: [
        { icon: Clock, text: "Disponible 24h/24 7j/7" },
        { icon: Zap, text: "Intervention rapide" },
        { icon: Shield, text: "Techniciens certifiés" },
        { icon: CheckCircle, text: "Devis transparent" }
      ],
      brands: "Toutes marques",
      image: "https://customer-assets.emergentagent.com/job_adm-confort-clim/artifacts/jgbghqme_WhatsApp%20Image%202026-03-15%20at%2022.05.57.jpeg",
      isEmergency: true
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-[#F8FAFC] py-16 lg:py-20" data-testid="services-hero">
        <div className="container-custom">
          <motion.div 
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="badge-primary mb-4">Nos services</span>
            <h1 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-bold text-[#000000] mt-4 mb-6">
              Climaticien & Frigoriste - Intervention France entière
            </h1>
            <p className="text-slate-600 text-base lg:text-lg">
              ADM Confort Clim : pose, dépannage et entretien de climatisation, pompe à chaleur, froid commercial et ventilation. Intervention rapide pour particuliers et professionnels.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16 lg:py-24" data-testid="services-list">
        <div className="container-custom">
          <div className="space-y-20 lg:space-y-24">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                id={service.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                data-testid={`service-${service.id}`}
              >
                {/* Content */}
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className={`inline-flex items-center gap-2 mb-4 ${service.isEmergency ? 'badge-emergency' : 'badge-primary'}`}>
                    <service.icon size={16} />
                    <span>{service.isEmergency ? 'Urgence 24h/24' : 'Service'}</span>
                  </div>
                  
                  <h2 className="font-outfit text-2xl md:text-3xl font-bold text-[#000000] mb-2">
                    {service.title}
                  </h2>
                  <p className="text-[#1997b0] font-medium mb-4 text-sm">{service.subtitle}</p>
                  <p className="text-slate-600 mb-6 text-sm leading-relaxed">{service.description}</p>

                  {/* Features */}
                  <div className="mb-6">
                    <h3 className="font-outfit font-semibold text-[#000000] mb-3 text-sm">Nos prestations :</h3>
                    <ul className="space-y-2">
                      {service.features.map((feature, i) => (
                        <li key={i} className="flex items-start gap-2 text-slate-600 text-sm">
                          <CheckCircle className="text-[#1997b0] flex-shrink-0 mt-0.5" size={16} />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="grid grid-cols-2 gap-3 mb-6">
                    {service.benefits.map((benefit, i) => (
                      <div key={i} className="flex items-center gap-2 bg-[#F8FAFC] p-3 rounded-lg">
                        <benefit.icon className="text-[#1997b0]" size={18} />
                        <span className="text-xs text-slate-700">{benefit.text}</span>
                      </div>
                    ))}
                  </div>

                  {/* Brands */}
                  <p className="text-xs text-slate-500 mb-6">
                    <span className="font-medium">Marques :</span> {service.brands}
                  </p>

                  {/* CTA */}
                  <div className="flex flex-col sm:flex-row gap-3">
                    {service.isEmergency ? (
                      <a 
                        href="tel:0603054911"
                        className="btn-emergency flex items-center justify-center gap-2 text-sm"
                        data-testid={`service-${service.id}-call`}
                      >
                        <Phone size={16} />
                        <span>06 03 05 49 11</span>
                      </a>
                    ) : (
                      <Link 
                        to="/contact"
                        className="btn-primary flex items-center justify-center gap-2 text-sm"
                        data-testid={`service-${service.id}-quote`}
                      >
                        <FileText size={16} />
                        <span>Demander un devis</span>
                      </Link>
                    )}
                    <a 
                      href="tel:0603054911"
                      className="btn-secondary flex items-center justify-center gap-2 text-sm"
                      data-testid={`service-${service.id}-contact`}
                    >
                      <Phone size={16} />
                      <span>Appeler maintenant</span>
                    </a>
                  </div>
                </div>

                {/* Image */}
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="relative">
                    <img 
                      src={service.image}
                      alt={`${service.title} Seine-et-Marne`}
                      className="w-full h-[300px] lg:h-[350px] object-cover rounded-2xl shadow-lg"
                    />
                    {service.isEmergency && (
                      <div className="absolute top-4 right-4 bg-[#fabc63] text-black px-4 py-2 rounded-full font-bold text-xs flex items-center gap-2">
                        <Clock size={14} />
                        24h/24 - 7j/7
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-16 lg:py-20 bg-[#F8FAFC]" data-testid="services-trust">
        <div className="container-custom">
          <motion.div 
            className="text-center mb-10"
            {...fadeInUp}
          >
            <h2 className="font-outfit text-2xl md:text-3xl font-bold text-[#000000] mb-3">
              Pourquoi choisir ADM Confort Clim ?
            </h2>
            <p className="text-slate-600 text-sm max-w-xl mx-auto">
              Entreprise sérieuse et locale, nous mettons notre expertise au service de votre confort depuis 13 ans.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {[
              { icon: Shield, title: "Garantie décennale", text: "Installations couvertes" },
              { icon: Clock, title: "Intervention rapide", text: "Disponible 24h/24" },
              { icon: CheckCircle, title: "Multi-marques", text: "Techniciens certifiés" },
              { icon: Zap, title: "Travail soigné", text: "Accompagnement personnalisé" }
            ].map((item, index) => (
              <motion.div
                key={index}
                className="bg-white p-5 rounded-xl text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="w-12 h-12 bg-[#1997b0]/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <item.icon className="text-[#1997b0]" size={22} />
                </div>
                <h3 className="font-outfit font-semibold text-[#000000] text-sm mb-1">{item.title}</h3>
                <p className="text-slate-600 text-xs">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#1997b0]" data-testid="services-cta">
        <div className="container-custom">
          <motion.div 
            className="text-center text-white"
            {...fadeInUp}
          >
            <h2 className="font-outfit text-2xl md:text-3xl font-bold mb-3">
              Besoin d'un devis ou d'une intervention ?
            </h2>
            <p className="text-white/80 mb-6 text-sm max-w-xl mx-auto">
              Contactez ADM Confort Clim pour un devis gratuit. Intervention partout en France.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a 
                href="tel:0603054911"
                className="btn-emergency flex items-center gap-2"
                data-testid="services-cta-call"
              >
                <Phone size={18} />
                <span>06 03 05 49 11</span>
              </a>
              <Link 
                to="/contact"
                className="bg-white text-[#1997b0] hover:bg-slate-100 transition-all duration-300 rounded-full px-6 py-3 font-semibold flex items-center gap-2 text-sm"
                data-testid="services-cta-contact"
              >
                <FileText size={18} />
                <span>Devis gratuit</span>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
